import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import { AppBridgeProvider } from './providers/AppBridgeProvider';
import { LanguageProvider, useLanguage } from './providers/LanguageProvider';
import { ThemeCompatibilityProvider } from './hooks/useThemeCompatibility';
import App from './App';

import enPolaris from '@shopify/polaris/locales/en.json';
import itPolaris from '@shopify/polaris/locales/it.json';

const polarisLocales = { en: enPolaris, it: itPolaris } as const;

function PolarisWrapper({ children }: { children: React.ReactNode }) {
  const { language } = useLanguage();
  return (
    <AppProvider i18n={polarisLocales[language]}>
      {children}
    </AppProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <PolarisWrapper>
        <AppBridgeProvider>
          <ThemeCompatibilityProvider>
            <App />
          </ThemeCompatibilityProvider>
        </AppBridgeProvider>
      </PolarisWrapper>
    </LanguageProvider>
  </React.StrictMode>
);
